import type { FC, SVGProps } from 'react';

export const MarginIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="16"
    height="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_6261_28081)">
      <rect width="16" height="16" fill="white" fillOpacity="0.01" />
      <path
        fill="#8C8C8C"
        d="M15.0003 12.1982H1.00027C0.9217 12.1982 0.857414 12.2625 0.857414 12.3411V13.3411C0.857414 13.4196 0.9217 13.4839 1.00027 13.4839H15.0003C15.0788 13.4839 15.1431 13.4196 15.1431 13.3411V12.3411C15.1431 12.2625 15.0788 12.1982 15.0003 12.1982ZM1.81634 9.96248L2.52527 10.6678C2.58063 10.7232 2.6717 10.7232 2.72706 10.6678L6.91813 6.49105L8.66099 8.22855C8.76836 8.33494 8.9134 8.39463 9.06456 8.39463C9.21571 8.39463 9.36075 8.33494 9.46813 8.22855L14.186 3.52855C14.2413 3.4732 14.2413 3.38212 14.186 3.32677L13.4771 2.61963C13.4502 2.59304 13.414 2.57813 13.3762 2.57812C13.3384 2.57812 13.3021 2.59304 13.2753 2.61963L9.06634 6.81605L7.3217 5.07855C7.21433 4.97217 7.06928 4.91248 6.91813 4.91248C6.76697 4.91248 6.62193 4.97217 6.51456 5.07855L1.81634 9.7607C1.80299 9.77389 1.79238 9.7896 1.78514 9.80691C1.7779 9.82423 1.77418 9.84282 1.77418 9.86159C1.77418 9.88036 1.7779 9.89895 1.78514 9.91626C1.79238 9.93358 1.80299 9.94929 1.81634 9.96248V9.96248Z"
      />
    </g>
    <defs>
      <clipPath id="clip0_6261_28081">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
